<template>
  <el-dialog :visible.sync="visible" width="500px" :footer-hide="true" custom-class="updatePwdDialog" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div class="text1">修改密码</div>
    <div class="text2">您的密码安全性较弱，请重新设置</div>
    <el-form ref="modalForm" class="my-form" :model="formData" label-position="right" :inline="false">
      <el-form-item prop="newPassword" :rules="{ required: true, message: '请输入新密码', trigger: 'blur' }">
        <el-input autocomplete="off" class="newpass passwordNone" size="small" type="text" v-model="formData.newPassword" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item prop="password2" :rules="{ required: true, message: '请再次输入新密码', trigger: 'blur' }">
        <el-input size="small" autocomplete="off" class="newpass passwordNone" type="text" v-model="formData.password2" placeholder="请再次输入新密码"></el-input>
      </el-form-item>
      <div class="dialog-footer">
        <div class="text3">注：新密码不少于8位，且必须包含大写字母、小写字母、数字、字符中的至少三种</div>
        <el-button type="primary" @click="save()" :loading='loading' class="saveBtn" :disabled="!formData.newPassword">保存</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      selectList: [],
      loading: false,
      modalLoading: false,
      formData: {
        newPassword: '',
        password2: '',
      },
      visible: false,
    }
  },
  methods: {
    open(id) {
      this.formData = {
        newPassword: '',
        password2: '',
      }
      // this.formData.id = id;
      this.visible = true
    },
    save() {
      this.$refs['modalForm'].validate((valid) => {
        if (!valid) {
          this.$message.warning('请按要求输入内容')
          return
        }
        if (this.formData.newPassword != this.formData.password2) {
          this.$message.warning('密码不一致，请确定新密码')
          return
        }
        this.$http({
          type: 'post',
          url: '/master/user/modify/password',
          params: {
            newPassword: this.formData.newPassword,
          },
        })
          .then((resData) => {
            if (resData.httpCode == 200) {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('loginSuccess')
            }
          })
          .catch((e) => {})
      })
    },
  },
}
</script>
<style lang="scss">
.updatePwdDialog {
  .el-dialog__header {
    padding: 0;
  }
  .dialog-footer {
    text-align: center;
    button {
      margin-right: 10px;
    }
  }
  .hide-input {
    width: 0;
    height: 0;
    position: absolute;
    z-index: -9999;
  }
  .el-form-item__content {
    width: 400px;
    margin: auto;
  }
  .passwordNone{
    .el-input__inner{
      -webkit-text-security:disc !important
    }
  }
  .newpass .el-input__inner {
    background-image: url('~@static/images/login/icon-mima.png');
    padding-left: 35px;
    background-position: 10px center;
    background-repeat: no-repeat;
  }
  .newpass1 .el-input__inner {
    background-image: url('~@static/images/login/icon-mima.png');
    padding-left: 35px;
    background-position: 10px center;
    background-repeat: no-repeat;
  }
  .el-input__inner {
    border: 1px solid #f7f8fa;
    line-height: 50px;
    font-size: 16px;
    width: 400px;
    height: 50px;
    background: #f7f8fa;
    border-radius: 4px;
  }
  .el-input-group__append {
    border: 0;
    padding: 0;
    width: 90px;
  }

  .text1 {
    font-size: 24px;
    font-weight: 400;
    line-height: 40px;
    color: #17233d;
    text-align: center;
  }
  .text2 {
    font-size: 14px;
    color: #515a6e;
    line-height: 20px;
    text-align: center;
    margin-bottom: 30px;
  }
  .text3 {
    width: 400px;
    margin: auto;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #8a9095;
    text-align: left;
    margin-bottom: 20px;
  }
  .saveBtn.is-disabled,
  .saveBtn.is-disabled:active,
  .saveBtn.is-disabled:focus,
  .saveBtn.is-disabled:hover {
    background: #ffbf91 !important;
    border-color: #ffbf91 !important;
  }
}
</style>






